import React, { useState } from 'react'

import { Card } from '@plurall/elo-beta'
import { UPDATE_PERSON_USERNAME } from 'graphql/mutations'
import PropTypes from 'prop-types'

import {
  graphqlClient,
  handleGraphQLErrors,
  hasRole,
  isDisableChangeMobilePhone,
  isDisableChangePersonalData,
  ROLE_STUDENT_ID,
} from 'utils'
import { trackingEventNames } from 'utils/trackings'

import Dialogs from './components/Dialogs/Dialogs'
import { RowWithDialog, RowWithInput } from './components/Rows'
import styles from './PersonalData.module.css'
import { dialogs, LOGIN_TYPE_ID, MESSAGES } from './utils/constants'
import { renderValidationText } from './utils/functions'

const CardAccessData = ({ data }) => {
  const [error, setError] = useState(null)
  const [email, setEmail] = useState(null)
  const [mobile, setMobile] = useState(null)
  const [updatedEmail, setUpdatedEmail] = useState(null)
  const [updatedMobile, setUpdatedMobile] = useState(null)
  const [openDialog, setOpenDialog] = useState(null)
  const [newUserName, setNewUserName] = useState(null)
  const [loading, setLoading] = useState(false)

  const { username } = data.users.find(({ typeUserId }) => typeUserId === LOGIN_TYPE_ID) || {}

  const { username: userNamePasswordChange } = data.users.find(({ typeUserId }) => typeUserId) || {}

  const mobileMask = () => {
    const { contacts } = data
    const phone = contacts[0] ? `${contacts[0].ddd}${contacts[0].number}` : null
    return phone?.length === 11
      ? phone.replace(/\D/g, '').replace(/(\d{2})(\d)(\d{4})(\d{4})$/, '($1) $2$3-$4')
      : ''
  }
  const updateUserName = async () => {
    try {
      setLoading(true)

      await graphqlClient().mutate({
        mutation: UPDATE_PERSON_USERNAME,
        variables: {
          id: Number(data.id),
          name: data.name,
          oldUsername: username || '',
          newUsername: newUserName,
          email: data.email,
        },
      })
      setError(null)
    } catch (error) {
      if (error.graphQLErrors) {
        if (!newUserName?.length && username) {
          return setError('Campo Obrigatório')
        }

        setError(handleGraphQLErrors(error.graphQLErrors))
      }
    } finally {
      setLoading(false)
    }
  }

  const showUsernameInput = !!hasRole(data, ROLE_STUDENT_ID)

  const handleUserNameChange = value => {
    setNewUserName(value)

    if (!value) {
      return setError('Campo Obrigatório')
    }

    return setError(null)
  }

  return (
    <>
      <div className={styles.card}>
        <Card
          title='Dados para acesso'
          description='Utilize seu nome de usuário, e-mail ou número de celular para entrar com sua conta no Plurall.'
          renderHeaderActions={() => {}}
        >
          <div className={styles['card-content']}>
            {showUsernameInput && (
              <RowWithInput
                name='Nome de usuário'
                value={username}
                onSave={updateUserName}
                onChange={handleUserNameChange}
                dataTestId='input-username'
                disabled={isDisableChangePersonalData({
                  byIntegration: data.byIntegration,
                  externalReferences: data.externalReference,
                })}
                {...renderValidationText(error, 'negative', error)}
                {...renderValidationText(loading, 'informative', MESSAGES.saving)}
              />
            )}
            <RowWithDialog
              name='E-mail'
              value={updatedEmail || data.email}
              openDialog={() => setOpenDialog(dialogs.edit_email)}
              dataTestId='input-edit-email'
              disabled={isDisableChangePersonalData({
                byIntegration: data.byIntegration,
                externalReferences: data.externalReference,
              })}
            />
            <RowWithDialog
              name='Número de celular'
              value={updatedMobile || mobileMask()}
              openDialog={() => setOpenDialog(dialogs.edit_cellphone)}
              dataTestId='input-edit-mobile'
              disabled={isDisableChangeMobilePhone({
                externalReferences: data.externalReference,
              })}
            />
            <RowWithDialog
              name='Senha'
              value='*******'
              openDialog={() => {
                window.PLURALL_TRACKER.track(
                  trackingEventNames.AccessData.student.openModalEditPassword,
                )
                setOpenDialog(dialogs.edit_password)
              }}
              dataTestId='input-edit-password'
              disabled={isDisableChangePersonalData({
                byIntegration: data.byIntegration,
                externalReferences: data.externalReference,
                canChangePassword: data.canChangePassword,
              })}
            />
          </div>
        </Card>
      </div>
      <Dialogs
        dialog={openDialog}
        setDialog={setOpenDialog}
        data={data}
        email={email}
        setEmail={setEmail}
        mobile={mobile}
        setMobile={setMobile}
        setUpdatedEmail={setUpdatedEmail}
        setUpdatedMobile={setUpdatedMobile}
        username={userNamePasswordChange}
        userId={data.id}
      />
    </>
  )
}

CardAccessData.propTypes = {
  data: PropTypes.shape({
    users: PropTypes.array,
    contacts: PropTypes.array,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string,
    byIntegration: PropTypes.bool.isRequired,
    canChangePassword: PropTypes.bool.isRequired,
    externalReference: PropTypes.arrayOf(
      PropTypes.shape({
        applicationName: PropTypes.string,
      }),
    ),
  }),
}

export default CardAccessData
